export default __webpack_public_path__ + "static/media/background-03.22940b70.jpg";